import { useNavigate } from '@tanstack/react-router'

import { type ClientPortalRelevantCaseItem } from '@/lib/queries/case-dashboard/types'

import { useClientPortalEoirPublicData } from '../../hooks/use-client-portal-eoir-public-data'

export const useClientPortalEoirPublicHeader = () => {
  const navigate = useNavigate()

  const {
    caseId: currentCaseId,
    caseNumber: currentCaseNumber,
    companyId,
    dataProUserSelectedCases,
  } = useClientPortalEoirPublicData()

  const copiedUrl = window.location.href

  const indexOfCurrentCaseId = dataProUserSelectedCases?.findIndex(({ caseId }) => caseId === currentCaseId)

  const handleClickCase = (caseItem: ClientPortalRelevantCaseItem) => {
    const { caseId } = caseItem
    void navigate({
      to: '/client-portal/eoir/public/$encodedCaseId',
      params: {
        encodedCaseId: btoa(`${caseId}`),
      },
      search: {
        companyId,
      },
    })
  }

  const handleClickPreviousButton = () => {
    if (indexOfCurrentCaseId === 0) {
      return
    }

    if (indexOfCurrentCaseId === undefined || !dataProUserSelectedCases) {
      return
    }

    const targetCaseId = dataProUserSelectedCases[indexOfCurrentCaseId - 1].caseId
    void navigate({
      to: '/client-portal/eoir/public/$encodedCaseId',
      params: {
        encodedCaseId: btoa(`${targetCaseId}`),
      },
      search: {
        companyId,
      },
    })
  }

  const handleClickNextButton = () => {
    if (dataProUserSelectedCases && indexOfCurrentCaseId === dataProUserSelectedCases?.length - 1) {
      return
    }

    if (!dataProUserSelectedCases || indexOfCurrentCaseId === undefined) {
      return
    }

    const targetCaseId = dataProUserSelectedCases[indexOfCurrentCaseId + 1].caseId
    void navigate({
      to: '/client-portal/eoir/public/$encodedCaseId',
      params: {
        encodedCaseId: btoa(`${targetCaseId}`),
      },
      search: {
        companyId,
      },
    })
  }

  return {
    currentCaseId,
    alienNumber: currentCaseNumber ? `A-${currentCaseNumber}` : '-',
    copiedUrl,
    dataProUserSelectedCases,
    handleClickCase,
    handleClickPreviousButton,
    handleClickNextButton,
  }
}
